import React from 'react';
import PropTypes from 'prop-types';

const FormatPercentRenderer = (props) => {
  const value = props.value;

  if (value !== null) {
    const numericValue = Number(value)
    return !isNaN(numericValue) ? `${numericValue}%` : <span className="tw-text-red-600">{value}</span>
  }

  return <span className="tw-text-red-600">N/A</span>
}

FormatPercentRenderer.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default FormatPercentRenderer;
